import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay';

const mutation = graphql`
    mutation ModifyPortfolios_esMutation($input: ModifyPortfoliosInput!) {
        modifyPortfolios(input: $input) {
            portfolio {
                id
                serviceId
            }
            portfolios {
                id
            }
        }
    }
`;

function getVariables(args) {
    const {
        action,
        portfoliosType,
        userId,
        portfolioIds,
        description,
        name,
        targetPortfolioId,
        startPortfolioId,
        endPortfolioId,
        privacyLevel,
    } = args;
    if (action === 'REMOVE') {
        return { action, portfolioIds: portfolioIds, portfoliosType, userId };
    } else if (action === 'ADD') {
        let inputs = { action, name: name, portfoliosType, userId };
        if (description) {
            inputs = { ...inputs, description: description };
        }
        if (privacyLevel) {
            inputs = { ...inputs, privacyLevel: privacyLevel };
        }
        return inputs;
    } else if (action === 'EDIT') {
        let inputs = { action, portfolioIds: portfolioIds, portfoliosType, userId };
        if (typeof description === 'string') {
            inputs = { ...inputs, description: description };
        }
        if (name) {
            inputs = { ...inputs, name: name };
        }
        if (privacyLevel) {
            inputs = { ...inputs, privacyLevel: privacyLevel };
        }
        return inputs;
    } else if (action === 'REORDER') {
        let inputs = { action, portfoliosType, targetPortfolioId: targetPortfolioId, userId };
        if (endPortfolioId) {
            inputs = { ...inputs, endPortfolioId: endPortfolioId };
        }
        if (startPortfolioId) {
            inputs = { ...inputs, startPortfolioId: startPortfolioId };
        }
        return inputs;
    }
    return null;
}

function commit(environment, args) {
    const variables = {
        input: getVariables(args),
    };
    return commitMutation(environment, {
        mutation,
        variables,
    });
}

export default { commit };
